import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {DisplayOnlyTable} from 'shells/table/display-only-table';

import type {ChangelogEventFragment} from 'nutshell-graphql-types';

type Props = {
    entries: any[];
    isLoading: boolean;
    error: string | null | undefined;
};

export function ChangelogTable(props: Props) {
    const {entries, isLoading, error} = props;

    const columns = React.useMemo(
        () => [
            {
                id: 'changeTime',
                Header: 'Time',
                accessor: (changelogEvent: ChangelogEventFragment) => changelogEvent.changeTime,
                dataType: 'timestamp',
                width: 200,
                hasLeftBorder: true,
            },
            {
                id: 'user',
                Header: 'User',
                accessor: (changelogEvent: ChangelogEventFragment) => changelogEvent.actor,
                dataType: 'component',
                width: 120,
                Cell: ({cell}: any) => {
                    // Actor can be a User or Origin, we only want to show type User here
                    return cell.value.__typename === 'User' ? (
                        <LinkedEntity {...cell.value} type='users' />
                    ) : (
                        <></>
                    );
                },
            },
            {
                id: 'changes',
                Header: 'Changes',
                accessor: (changelogEvent: ChangelogEventFragment) => changelogEvent,
                dataType: 'component',
                width: 200,
                Cell: ({cell}: any) => {
                    const changeBullets = [<div key='1'>{cell.value.description}</div>];
                    const changesBullets =
                        cell.value.automations.length > 0
                            ? // @ts-expect-error
                              cell.value.automations.map((automation, index) => (
                                  <div key={index}>
                                      {automation ? automation.humanReadableDescription : ''}
                                  </div>
                              ))
                            : // @ts-expect-error
                              cell.value.changes.map((change, index) => (
                                  <div key={index}>{change ? change.description : ''}</div>
                              ));

                    const bullets = cell.value.description ? changeBullets : changesBullets;

                    return <BulletedList size='small' bullets={bullets} greyBullets={true} />;
                },
            },
            {
                id: 'origin',
                Header: 'Origin',
                accessor: (changelogEvent: ChangelogEventFragment) =>
                    changelogEvent.origin.name || '',
                dataType: 'string',
                width: 100,
                hasRightBorder: true,
            },
        ],
        []
    );

    return (
        <DisplayOnlyTable
            // @ts-expect-error
            columns={columns}
            data={entries}
            isLoading={isLoading}
            error={error}
            emptyStateText='No changelog entries were found'
        />
    );
}
